import { Component, OnInit, Inject, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import * as Services from '@shared/core/services';
import * as Tokens from '@shared/core/tokens';
import { Controllers } from '@shared/core/controllers';
import { ICellVerifyForm } from '@shared/core/components/cellVerify';

import { FormTypesComponent } from '../form-types.shared.component';
import { FormsSubmitComponent } from '../../components/formsSubmit/forms-submit.shared.component';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-form-for-cell-verify',
    templateUrl: './form-for-cell-verify.shared.component.html',
    styleUrls: ['./form-for-cell-verify.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormForCellVerifyComponent extends FormTypesComponent implements OnInit {
    public codeObj: ICellVerifyForm = {
        isValid: false,
        value: null,
    };

    @Input() public step: OLO.Enums.AUTH_STEP;
    @ViewChild('btn') public submitComponent: FormsSubmitComponent;
    public invalid$: Observable<boolean>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
        public membersService: Services.MembersService,
    ) {
        super(config, formBuilder);
        this.formName = 'cell-verify';
    }

    ngOnInit(): void {
        this.loading$ = this.controllers.members.mobilePhoneStatus$();
        this.invalid$ = this.controllers.members.cellVerificationError$();
    }

    public handleVerifyChange($event: ICellVerifyForm): void {
        this.codeObj = $event;
        this.changeDetectorRef.detectChanges();
    }

    public handleVerifyComplete($event: ICellVerifyForm): void {
        if (this.submitComponent && this.submitComponent.btn) {
            setTimeout(() => {
                const btn = (this.submitComponent.btn as any)?.elementRef?.nativeElement?.querySelector('button');
                if (btn) {
                    btn.focus();
                }
            }, 100);
        }
    }

    public handleResendCodeClick($event: Event): void {
        this.membersService.resendTemporaryVerificationCode();
    }

    public handleCellVerifySubmit($event: Event): void {
        this.controllers.members.verifyTemporaryVerificationCode(this.codeObj.value);
    }
}
